import React from 'react';

const IconShipping = props => {
  const { className } = props;
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <g
        fill="none"
        stroke="#115a36"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="scale(3.42857)"
      >
        <circle cx={6} cy={12.49} r={1} />
        <circle cx={10.5} cy={12.49} r={1} />
        <path d="M8.38 3.53A4 4 0 102 7.62M4.5 4.51L6 3.01M6.5 9.5v-1H5a2 2 0 00-2 2v2" />
        <path d="M13.5 12.49v-5a1 1 0 00-1-1h-5a1 1 0 00-1 1v2" />
      </g>
    </svg>
  );
};

export default IconShipping;
